import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CUSTOMISATION_OPTIONS } from "../../constants/all-customisation-options";
import {
  selectEditing,
  selectOptionFromKey,
  updateOtherOptionValueByKey,
} from "../../customisation-slice";
import { useSidebarAnimationContext } from "../../providers/sidebar-animation-provider";
import { useWatchViewContext } from "../../providers/watch-view-provider";
import Button from "../button";
import SidebarActionButtons from "../sidebar-action-buttons";
import EditingDisabled from "./editing-disabled";
import EditingGrid from "./editing-grid";
import EngravingView from "./engraving-view";
import InitialsView from "./initials-view";
import Navigation from "./navigation";
import SecondsHandView from "./seconds-hand-view";

const EditingBarContainer = () => {
  const dispatch = useDispatch();
  const editingKey = useSelector(selectEditing);
  const selectedOption = useSelector((state) =>
    selectOptionFromKey(state, editingKey)
  );
  const editingOptions = CUSTOMISATION_OPTIONS[editingKey].options;
  const [showInitialsColors, setShowInitialsColors] = useState(false);
  const initialsState = useSelector((state) =>
    selectOptionFromKey(state, "initials")
  );
  const { goToSpecificView } = useWatchViewContext();
  const { updateEditStateWithAnimation } = useSidebarAnimationContext();

  useEffect(() => {
    goToSpecificView(selectedOption.defaultViewIndex);
  }, [editingKey, selectedOption.defaultViewIndex]);

  const switchContent = () => {
    if (editingKey === "seconds") {
      return renderSecondHandView();
    } else if (editingKey === "initials") {
      return renderInitialsView();
    } else if (editingKey === "engraving") {
      return renderEngravingView();
    } else if (editingKey === "stamp" && initialsState.text !== "") {
      return renderEditingDisabledView();
    }
    return renderDefaultView();
  };

  const renderSecondHandView = () => (
    <SecondsHandView
      editingOptions={editingOptions}
      selectedOption={selectedOption.selected}
    />
  );

  const renderInitialsView = () => (
    <InitialsView
      editingOptions={editingOptions}
      selectedOption={selectedOption}
      showInitialsColors={showInitialsColors}
    />
  );

  const renderEngravingView = () => (
    <EngravingView selectedOption={selectedOption} />
  );

  const renderEditingDisabledView = () => (
    <EditingDisabled
      instruction="The stamp is placed on the watch dial in the same position as any initials. Please remove your initials to apply a stamp"
      buttonOnClick={() =>
        dispatch(
          updateOtherOptionValueByKey({
            optionKey: "initials",
            valueKey: "text",
            value: "",
          })
        )
      }
      buttonText="Remove Initials"
    />
  );

  const renderDefaultView = () => (
    <EditingGrid
      editingOptions={editingOptions}
      selectedOption={selectedOption.selected}
    />
  );

  const actionButtons = [
    <Button
      key="Ok"
      label="Ok"
      onClick={() => updateEditStateWithAnimation(null)}
    />,
  ];

  if (editingKey === "initials") {
    actionButtons.push(
      <Button
        key="Mode Switch"
        label={showInitialsColors ? "Enter Initials" : "Change Colour"}
        className="md:hidden"
        outline={true}
        onClick={() => setShowInitialsColors(!showInitialsColors)}
      />
    );
  }

  return (
    <>
      <Navigation />
      {switchContent()}
      <SidebarActionButtons buttons={actionButtons} />
    </>
  );
};

export default EditingBarContainer;
